import type { PermissionSelector } from "hooks/usePermission";

export const canManageCategories: PermissionSelector = (x) => x.isAdmin && x.repairManagement.canManageCategories;

export const canListStatuses: PermissionSelector = (x) => x.isAdmin && x.repairManagement.canListStatuses;
